import React, {Component} from 'react'
import SearchFieldRow  from './search_field_row'

export default class CollectionSearchFields extends Component {
  constructor(props){
    super(props);
    this.data_types = this.props.data_types;
    this.possible_fields = this.props.possible_fields;
    this.state = { rows: this.props.rows, status: "",  loading: false, error_message: ""};
    this.rowChange = this.rowChange.bind(this);
    this.rowRemove = this.rowRemove.bind(this);
    this.loading = this.loading.bind(this);
    this.rowAdd =  this.rowAdd.bind(this);
    this.save = this.save.bind(this);
    this.Status= this.Status.bind(this);
    this.clearState = this.clearState.bind(this);
  }

  loading(){
    if (this.state.loading){
      return "Loading...";
    }
    else {
      return "Save";
    }
  }

  rowChange(row){
    var r = this.state.rows;
    var data = r.find(function (r){ return r.key == row.key});
    data = row;

  
    this.setState({rows: r.sort(this.orderSort)});
  }

  orderSort(a, b){
    const order1 = parseInt(a.order);
    const order2 = parseInt(b.order);

    let comparison = 0;
    if (order1 > order2) {
      comparison = 1;
    } else if (order1 < order2) {
      comparison = -1;
    }
    return comparison;

  }

   clearState(){
    this.setState({status: ""});
  }


  
 Status(){
  //return <p>{this.state.status}</p>;

   if (this.state.status === 201 || this.state.status === 200){
    return (<div className="alert-success text-center" style={{padding: "10px"}}>
        <button className='close'
          onClick={this.clearState}> &times; </button> Success!
          </div>

          );
   }
   else if (this.state.status > 400){
    return (<div className="alert-danger text-center" style={{padding: "10px"}}>
        <button className='close'
          onClick={this.clearState}> &times; </button> {this.state.error_messages}
          </div>
          );
  }
   
  }


  rowRemove(row){
    var rows = this.state.rows;

    if (row.id){
      this.delete(row);
    }

    var data = rows.filter(function (r){ return r.key != row.key});
    rows = data;

    this.setState({rows: data});

  }

  delete(row){
    var t = this;
    var url = Routes.rmrc_ad_product_collection_search_field_path(row.product_collection_id, row.id);

    $.ajax({
      method: 'DELETE',
      url: url,
      dataType: 'JSON',

      success: function(data, statusText, xhr){
        console.log(data);
      },
      error: function(data, statusText, xhr){
        console.log(data);

      }
    });
  }


  save(event){
    var t = this;
    var url = Routes.rmrc_ad_product_collection_search_fields_update_path(t.props.collection_id);
    t.setState({loading: true});
    $.ajax({
      method: 'POST',
      url: url,
      dataType: 'JSON',
      data: {search_fields: t.state.rows},
      success: function(data, statusText, xhr){

        t.setState({loading: false});
        
        t.setState({status: xhr.status});
      },
      error: function(data, statusText, xhr){
        t.setState({loading: false});
        t.setState({status: data.status, error_messages: data.responseText });
      }
    });
  }


  rowAdd(){

    let r = this.state.rows;
    let new_row_key = -(r.length - 1)

    r.push({name: "", product_collection_id: this.props.collection_id, order: this.state.rows.length - 1,  key: new_row_key, label:"", data_type: "keyword",
     is_filter: true, spec_key:"", product_type_question_id: this.props.possible_fields[0].id });

    this.setState({rows: r});
  }

  render(){
    let t = this;
    let rows = this.state.rows.map(function (m){
      return (
        <SearchFieldRow data={m} data_types={t.data_types} possible_fields={t.possible_fields}  key={m.id || m.key} updateRow={t.rowChange} removeRow={t.rowRemove}  />
      );
    });

    return (
      <div>
       {t.Status()}
      <table className="table table-condensed">
      <thead>
      <tr>
      <th>
      Filter Display Name
      </th>
      <th>
      Product Spec
      </th>
      <th>
      Data Type
      </th>
      <th>
       Visible 
      </th>
      <th>
      Order
      </th>
      </tr>
      </thead>
      <tbody>
      {rows}
      </tbody>
      <tfoot>
      <tr>
      <td><button className="btn btn-info" onClick={t.rowAdd} ><i className="glyphicon glyphicon-plus"></i></button></td>
      <td></td>
      <td></td>
      <td colSpan="100%">
      <button className="btn btn-success" disabled={this.state.loading || this.state.rows.length < 1} onClick={t.save}>{this.loading()}</button>
      </td>
      </tr>
      </tfoot>
      </table>
      </div>

    );
  }
}




// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/components/collection_search_fields.jsx